// extracted by mini-css-extract-plugin
module.exports = {"spotlightLeft":"SpotlightFrame_spotlightLeft__pJIny","spotlightRight":"SpotlightFrame_spotlightRight__sKoET"};